import React from 'react';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { selectAgentExecutionSelected } from 'store/Agents/selectors';
import { Wrapper, COMPLETED, FAILED, RUNNING } from '../../../../../StatusCell/styled';

const StatusInfo = () => {
  const agentExecutionSelected = useSelector(selectAgentExecutionSelected);
  const running = get(agentExecutionSelected, '[0].running', false);
  const successful = get(agentExecutionSelected, '[0].successful', false);

  const getStatus = () => {
    if (running) return RUNNING;
    if (successful) return COMPLETED;
    return FAILED;
  };

  return <Wrapper title={ getStatus() }status={ getStatus() }>{getStatus()}</Wrapper>;
};

export default StatusInfo;
